import { createElement } from 'react'

import Helmet from 'react-helmet'
import serialize from 'serialize-javascript'

import { Page } from '@tribeplatform/gql-client/types'

export const PageMeta = ({ page }: { page: Page }) => {
  const seoDetail = page?.seoDetail
  if (!seoDetail) {
    return null
  }

  const { additionalMeta, title, description, jsonld } = seoDetail
  let serializedJsonld
  try {
    if (typeof jsonld === 'string') {
      serializedJsonld = serialize(JSON.parse(jsonld), { isJSON: true })
    }
  } catch (e) {
    serializedJsonld = undefined
  }

  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {additionalMeta?.map(tag => {
        try {
          return createElement(tag.type.toLowerCase().trim(), {
            ...tag.properties.reduce((props, keyValue) => {
              return {
                ...props,
                [keyValue.key]: keyValue.value,
              }
            }, {}),
          })
        } catch (error) {
          logger.error('error parsing additional meta tags', { tag, error })
        }
        return null
      })}
      {serializedJsonld && (
        <script type="application/ld+json">{serializedJsonld}</script>
      )}
    </Helmet>
  )
}
